<template>
  <div
    class="notification-holder"
    :style="`background-color:${
      notification.seen_at ? '#e3e3e3' : colors[notification.notification_type]
    }`"
  >
    <!-- New Apt Request -->
    <div v-if="notification.notification_type === 'new_request'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >NEW REQUEST</span
      >
      You have an Apt Request from
      <strong>{{
        notification.appointment_pass.from.name
          ? notification.appointment_pass.from.name
          : notification.appointment_pass.from.first_name +
            " " +
            notification.appointment_pass.from.last_name
      }}</strong>
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{
          $helpers.transformDate(
            notification.appointment_pass.for_date,
            "h:mm A"
          )
        }}</strong
      >
      for
      {{ $helpers.transformDate(notification.appointment_pass.for_date) }}.
    </div>

    <!-- Cancelled Apt Request -->
    <div v-if="notification.notification_type === 'cancelled'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >CANCELLED</span
      >
      Your Apt Request from
      <strong>{{
        notification.appointment_pass.from.name
          ? notification.appointment_pass.from.name
          : notification.appointment_pass.from.first_name +
            " " +
            notification.appointment_pass.from.last_name
      }}</strong>
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{
          $helpers.transformDate(
            notification.appointment_pass.for_date,
            "h:mm A"
          )
        }}</strong
      >
      for
      {{ $helpers.transformDate(notification.appointment_pass.for_date) }}
      has been cancelled by
      <strong
        >{{
          notification.updated_by
            ? notification.updated_by.first_name +
              " " +
              notification.updated_by.last_name
            : "Somebody"
        }}.</strong
      >
    </div>

    <!-- Moved Apt Request -->
    <div v-if="notification.notification_type === 'moved'">
      <span
        class="notification-text-holder"
        :style="`background-color:${
          notification.seen_at ? '#fff' : colors[notification.notification_type]
        }; color:${notification.seen_at ? '#000' : '#fff '}`"
        >MOVED</span
      >
      Your Apt Request from
      <strong>{{
        notification.appointment_pass.from.name
          ? notification.appointment_pass.from.name
          : notification.appointment_pass.from.first_name +
            " " +
            notification.appointment_pass.from.last_name
      }}</strong>
      at
      <strong style="word-break: keep-all; white-space: nowrap">
        {{ $helpers.transformDate(notification.old_time, "h:mm A") }}</strong
      >
      for {{ $helpers.transformDate(notification.old_time) }} has been moved to
      <strong style="word-break: keep-all; white-space: nowrap">
        {{ $helpers.transformDate(notification.new_time, "h:mm A") }}</strong
      >
      for {{ $helpers.transformDate(notification.new_time) }} by
      <strong
        >{{
          notification.updated_by
            ? notification.updated_by.first_name +
              " " +
              notification.updated_by.last_name
            : "Somebody"
        }}.</strong
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "AdultAppointmentNotification",
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  setup() {
    const colors = {
      new_request: "#4a7cab",
      cancelled: "#8a8fdf",
      moved: "#efd4bc"
    }

    return { colors }
  }
}
</script>
